<template>
  <div>
    <v-container class="pa-0 my-page-content">
      <v-layout row wrap justify-center>
        <v-flex xs12 v-if="tab == 'list'">
          <articles :articles="bookmarks.articles" />
        </v-flex>
        <v-flex xs12 v-if="tab == 'users'">
          <users :users="bookmarks.users" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-bottom-nav fixed :value="true" :active.sync="tab" color="white">
      <v-btn flat color="teal" value="list">
        <v-icon>list</v-icon>
      </v-btn>
      <v-btn flat color="teal" value="users">
        <v-icon>group</v-icon>
      </v-btn>
    </v-bottom-nav>
  </div>
</template>

<script>
  import request from 'superagent'
  import Articles from './bookmark/Articles'
  import Users from './bookmark/Users'

  export default {
    components: {
      'articles': Articles,
      'users': Users
    },
    created () {
      const username = this.$route.params.username
      request.get('https://mxgtg0n5i0.execute-api.ap-northeast-1.amazonaws.com/dev/bookmarks/' + username)
      .then(res => (this.bookmarks = res.body))
    },
    data () {
      return {
        tab: 'list',
        bookmarks: {
          articles: [],
          users: []
        }
      }
    }
  }
</script>

<style>
  .my-page-content {
    top: 0px;
    margin-bottom: 56px;
    overflow: scroll;
  }
</style>


// WEBPACK FOOTER //
// src/components/BookmarkList.vue